import { createContext } from 'react';
import type { ExportLanguageValue } from './exportLanguage';

/* Kept out of exportLanguage.tsx, which imports ./ui, the session and the
   translations. See src/core/i18nContext.ts. */
export const ExportLanguageContext = createContext<ExportLanguageValue | null>(null);
